// https://gist.github.com/beaucharman/1f93fdd7c72860736643d1ab274fee1a#gistcomment-2994421
export const debounce = (fn, wait) => {
    let t
    return function () {
        clearTimeout(t)
        t = setTimeout(() => fn.apply(this, arguments), wait)
    }
};